import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import { Box, Button, Divider} from '@mui/material';
import { useState } from 'react';
import PageBreadCrumbs from '../../../components/PageBreadcrumbs';


const CMRs = [
    {
        title: "970 CMR 1.00: Campaign Finance Activity",
        url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/970CMR1.pdf#navpanes=0&statusbar=0&view=FitH"
    },
    {
        title: "970 CMR 2.00: Political Expenditures",
        url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/970CMR2.pdf#navpanes=0&statusbar=0&view=FitH"
    },
    {
        title: "970 CMR 3.00: Rules of Procedure",
        url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/970CMR3.pdf#navpanes=0&statusbar=0&view=FitH"
    },
    {
        title: "970 CMR 4.00: Public Finance Regulations",
        url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/970CMR4.pdf#navpanes=0&statusbar=0&view=FitH"
    }
]

const Regulations = (): JSX.Element => {

  document.title = 'OCPF -  970 CMR Regulations';

  const [active, setActive] = useState<number | null>(0);
  const [iframeSrc, setIframeSrc] = useState<string>("https://ocpf2.blob.core.windows.net/pdf/legaldocs/970CMR1.pdf#navpanes=0&statusbar=0&view=FitH");
  
  const handleButtonClick = (url: string, cellIndex: number) => {
    setIframeSrc(url);
    setActive(cellIndex);
  }

  return (
    <Main>
      <Container>
      <PageBreadCrumbs></PageBreadCrumbs>
      <Typography
                variant="h5"
                align={'left'}
                data-aos={'fade-up'}
                gutterBottom
                sx={{
                  fontWeight: 700,
                }}
                paddingTop={3}>
                970 CMR: Office of Campaign & Political Finance 
              </Typography>
              <Typography  variant="subtitle2" 
                data-aos={'fade-up'}
                color="text.secondary"
                marginBottom={2}>The Code of Massachusetts Regulations</Typography>
        
        <Divider/>

        <Box sx={{marginTop: 2, marginBottom: 2}}>
            <Typography variant="h6" align={'left'} fontWeight={'bold'}>
            OCPF Notice
              </Typography>
              <Typography variant="body1" align={'left'} >
              The OCPF website provides an unofficial version of these regulations. The official version of these regulations on file with the State Publications and Regulations Division of the Secretary of State's Office will control in the event of any discrepancy with the information contained on this website. Please contact the Regulations Division to obtain an official version of these regulations at:  Telephone: (617) 727-2831 or Fax: (617) 742-4822.
              </Typography>
        </Box>

        {
          CMRs.map((cmr, index) => ( 
             
            <Button 
            variant={active === index ? 'contained' : 'text'}
            color={active === index ? 'primary' : 'inherit'}
            fullWidth sx={{justifyContent: "flex-start"}} key={index} onClick={() => handleButtonClick(cmr.url, index)}>
              {cmr.title}
            </Button>
          ))
        }

        <Box marginTop={5} marginBottom={2}>
          <iframe aria-label='Regulation PDF displayed' title='Regulation PDF displayed' src={iframeSrc} width="100%" height="800px"></iframe>
        </Box>
           
        <Box>
          <Typography variant="body1" align={'left'} fontWeight={'bold'} >
          REGULATORY AUTHORITY <br/>
          970 CMR 1.00: M.G.L. c. 55, §§ 3, 6 and 10A.
          </Typography>
        </Box>
      </Container>
    </Main>
  );
};

export default Regulations;